import { render, staticRenderFns } from "./detailItemDisplayInformation.vue?vue&type=template&id=7a522cca&"
import script from "./detailItemDisplayInformation.vue?vue&type=script&lang=js&"
export * from "./detailItemDisplayInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports